import React, { useState } from "react";
import { Row, Col } from "antd";
import CustomFieldsComponent from "./customFields/index";
import { UseCustomFields } from "./customFields/useCustomFields";
import RevisionsFieldsComponent from "./RevisionFilters/index";
import { UseRevisionFields } from "./RevisionFilters/useRevisionFields";
import DistributionFieldsComponent from "./DistributionFilters/index";
import { UseDistributionFields } from "./DistributionFilters/useDistributionFields";
import { ReactComponent as FilterIcon } from "../../../../assets/filter.svg";
import { ReactComponent as CrossIcon } from "../../../../assets/crossIcon.svg";
import moment from "moment";
import { useSelector } from "react-redux";
import UseDocControlPermissions from "../../permissions/useDocControlPermissions";
import { shouldAllow } from "../../utils";

const FilterSection = ({
  handleFilter,
  handleClose,
  selectedTemplate,
  setSelectedTemplate,
  setFilterDataFetched,
  dynamicFieldsOptions,
  setDynamicFieldsOptions,
  project_id,
}) => {
  const [custom, setCustom, createCustom, deleteCustom, updateCustom] =
    UseCustomFields();

  const [rev, setRev, createRev, deleteRev, updateRev] = UseRevisionFields();

  const [dist, setDist, createDist, deleteDist, updateDist] =
    UseDistributionFields();
  const [, canEdit] = UseDocControlPermissions();
  
  const [selectedFilterType, setSelectedFilterType] = useState("material");

  const { isCollapsed } = useSelector((state) => state.authReducer);

  // Check if any filters are selected
const hasFilters = () => {
  return custom.some(el => shouldAllow(el)) || 
         rev.some(el => shouldAllow(el)) || 
         dist.some(el => shouldAllow(el));
};

const handleOnClick = () => {
    let obj = {};
    obj["materialTemplateId"] = selectedTemplate.id;
    obj["filter"] = true;
    obj["type"] = selectedFilterType;
    obj["projectId"] = project_id;

    let materialTemplateFields = {};

    if (custom.length > 0) {
      custom.forEach((el) => {
        if (shouldAllow(el)) {
          const { name, value, option } = el;
          const { field_type } = option;
          
          // Get the field information from the option object
          const selectedField = option.selectedField;

          // Format the field name as lowercase with spaces replaced by underscores
          let fieldName;
          if (selectedField) {
            // Use the original field name but convert to lowercase and replace spaces with underscores
            fieldName = selectedField.name.toLowerCase().replace(/\s+/g, '_');
          } else if (option.field_name) {
            // Try using the field_name stored in option but convert to lowercase and replace spaces with underscores
            fieldName = option.field_name.toLowerCase().replace(/\s+/g, '_');
          } else {
            // Fallback if field not found
            fieldName = `field_${value}`;
          }

          let field_value =
            field_type === "date" || field_type === "date_field"
              ? moment(name).format("YYYY-MM-DD")
              : field_type === "selector" || field_type === "select_field"
              ? (option?.options || option?.field_options)?.find(ele => ele.id === name || ele === name)?.name || name
              : name;
              
          // Add +1 to field_value when field_type is 'selector'
          if (field_type === "selector") {
            field_value = parseInt(field_value) + 1;
          }
          // Use the field name as key and field_value as value
          materialTemplateFields[fieldName] = field_value;
        }
      });
    }

    let revisions = [];

    if (rev.length > 0) {
      rev.forEach((el) => {
        if (shouldAllow(el)) {
          const { name, value } = el;
          revisions.push({ [value]: name });
        }
      });
    }

    let materialControlFilters = [];

    if (dist.length > 0) {
      dist.forEach((el) => {
        if (shouldAllow(el)) {
          const { name, value } = el;
          materialControlFilters.push({ [value]: name });
        }
      });
    }

    if (Object.keys(materialTemplateFields).length > 0) {
      obj["materialTemplateFields"] = materialTemplateFields;
    }

    if (revisions.length > 0) {
      obj["revisions"] = revisions;
    }

    if (materialControlFilters.length > 0) {
      obj["materialControlFilters"] = materialControlFilters;
    }

    handleFilter(obj);
    setFilterDataFetched(true);
  };

  const handleSelectTemplate = () => {
    setCustom([]);
    setRev([]);
    setDist([]);
  };

  return (
    <Col span={24} className="ims-doc-filter-section">
      <Row align="middle" justify="space-between" className="filter-header">
        <Col className="filter-col">
          <FilterIcon /> FILTER
        </Col>
        <Col>
          <CrossIcon className="cross-icon" onClick={handleClose} />
        </Col>
      </Row>
      <Row gutter={[20, 20]} className="sections-row" justify="center">
        <Col className={`sub-sections-col${isCollapsed ? "-collapsed" : ""}`} style={{ flex: '1' }}>
          <div className="label-div">
            <span>EXPANDED FIELDS FILTERS</span>
          </div>
          <DistributionFieldsComponent
            inputFields={dist}
            setInputFields={setDist}
            createField={createDist}
            deleteField={deleteDist}
            updateField={updateDist}
            canUpdate={true}
            selectedTemplate={selectedTemplate}
            onTypeChange={setSelectedFilterType}
            project_id={project_id}
          />
        </Col>
        <Col className={`sub-sections-col${isCollapsed ? "-collapsed" : ""}`} style={{ marginLeft: '40px', flex: '1' }}>
          <div className="label-div">
            <span>TEMPLATE FIELDS FILTERS</span>
          </div>
          <CustomFieldsComponent
            inputFields={custom}
            setInputFields={setCustom}
            createField={createCustom}
            deleteField={deleteCustom}
            updateField={updateCustom}
            canUpdate={true}
            selectedTemplate={selectedTemplate}
            setSelectedTemplate={setSelectedTemplate}
            handleSelectTemplate={handleSelectTemplate}
            dynamicFieldsOptions={dynamicFieldsOptions}
            setDynamicFieldsOptions={setDynamicFieldsOptions}
            project_id={project_id}
          />
        </Col>
        <Col
          className={`sub-sections-filter-col${
            isCollapsed ? "-collapsed" : ""
          }`}
          style={{ marginLeft: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <div className="filter-div">
            <div 
              onClick={hasFilters() ? handleOnClick : undefined} 
              style={{ 
                cursor: hasFilters() ? 'pointer' : 'not-allowed',
                color: hasFilters() ? '#FF6B35' : '#cccccc',
                border: hasFilters() ? '1px solid #FF6B35' : '1px solid #cccccc',
                opacity: hasFilters() ? 1 : 0.7
              }}
            >
              Apply <br /> Filters
            </div>
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default FilterSection;
